export enum ContactEvents {
  EmployeeCreated = 'contact.employee.Created',
  PersonCreated = 'contact.person.Created',
  CompanyCreated = 'contact.company.Created'
}
